import React from "react";
import { FiInfo } from "react-icons/fi";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { Skeleton } from "@/components/skeleton/Skeleton";

export interface DashboardStat {
    label: string;
    value: string;
    info?: string;
}

interface StatCardProps {
    stat: DashboardStat;
}

export const StatCard: React.FC<StatCardProps> = ({ stat }) => {
    const tooltipId = `stat-info-${stat.label.replace(/\s+/g, "-").toLowerCase()}`;

    return (
        <div className="relative bg-p-gray px-2 py-3 sm:px-8 sm:py-5 rounded-2xl text-center font-semibold w-full sm:flex-1 sm:min-w-44">
            {stat.info && (
                <>
                    <span
                        data-tooltip-id={tooltipId}
                        className="absolute top-1.5 right-1.5 sm:top-2.5 sm:right-2.5 inline-flex cursor-pointer text-gray-400 hover:text-gray-600"
                        aria-label={`How ${stat.label} is calculated`}
                    >
                        <FiInfo className="w-3 h-3 sm:w-4 sm:h-4" />
                    </span>
                    <ReactTooltip
                        id={tooltipId}
                        place="bottom"
                        content={stat.info}
                        className="!max-w-[240px] !text-xs !font-normal !text-left !rounded-lg z-50"
                    />
                </>
            )}
            <p className="text-base sm:text-[28px] truncate">{stat.value}</p>
            <p className="text-primary-red text-[11px] sm:text-sm truncate">{stat.label}</p>
            {/* <p className="text-gray-400 text-xs mt-1">{stat.sublabel}</p> */}
        </div>
    );
};

export const StatCardSkeleton = () => (
    <div className="bg-p-gray px-2 py-3 sm:px-8 sm:py-5 rounded-2xl w-full sm:flex-1 sm:min-w-44 flex flex-col items-center gap-2">
        <Skeleton className="h-6 sm:h-8 w-16" />
        <Skeleton className="h-3 w-20" />
    </div>
);
